module.exports = __webpack_public_path__ + "img/vertical_3_6_8011.241906b2.png";